import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-caption ml-2"
}
const _hoisted_2 = { class: "d-flex align-center ga-3" }
const _hoisted_3 = { class: "text-white" }

import { computed } from 'vue'

interface Request {
  id: string
  student_name?: string
  school: string
  grade_level: string
  equipment_type: string
  minimum_rating?: number
  status: string
  submitted_at: string
}

interface School {
  id: string
  _id?: string
  name: string
}

interface Props {
  requests: Request[]
  loading?: boolean
  isAdmin?: boolean
  schools: School[]
  selectedItems?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestsTable',
  props: {
    requests: { default: () => [] },
    loading: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
    schools: { default: () => [] },
    selectedItems: { default: () => [] }
  },
  emits: ['selectRequest', 'fill', 'markDelivered', 'edit', 'delete', 'update:selectedItems', 'bulkEdit', 'bulkMarkDelivered', 'printDeliverySlips'],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-undef */
const props = __props

const emit = __emit

const selectedItemsModel = computed({
  get: () => props.selectedItems,
  set: (value) => emit('update:selectedItems', value)
})

// Check if any selected requests have 'filled' status
const anySelectedAreFilled = computed(() => {
  if (selectedItemsModel.value.length === 0) return false
  return selectedItemsModel.value.some(id => {
    const request = props.requests.find(r => r.id === id)
    return request && request.status === 'filled'
  })
})

// Get only the filled request IDs from selection
const filledRequestIds = computed(() => {
  return selectedItemsModel.value.filter(id => {
    const request = props.requests.find(r => r.id === id)
    return request && request.status === 'filled'
  })
})

const headers = [
  { title: 'Student', key: 'student_name', sortable: true },
  { title: 'School', key: 'school', sortable: true },
  { title: 'Grade', key: 'grade_level', sortable: true },
  { title: 'Asset Tag', key: 'assigned_asset_tag', sortable: true },
  { title: 'Status', key: 'status', sortable: true },
  { title: 'Submitted', key: 'submitted_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false }
]

const getInitials = (name: string) => {
  if (!name) return '?'
  const parts = name.split(' ')
  if (parts.length >= 2) {
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
  }
  return name.charAt(0).toUpperCase()
}

const formatEquipmentType = (type: string) => {
  if (!type) return 'Unknown'
  return type.charAt(0).toUpperCase() + type.slice(1)
}

const formatStatus = (status: string) => {
  if (!status) return 'Unknown'
  return status.split('_').map(word =>
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ')
}

const formatDate = (date: string) => {
  if (!date) return 'N/A'
  return new Date(date).toLocaleDateString()
}

const getRequestStatusColor = (status: string) => {
  const statusColors: Record<string, string> = {
    pending: 'warning',
    filled: 'info',
    completed: 'success',
    denied: 'error'
  }
  return statusColors[status] || 'grey'
}

const getSchoolName = (schoolId: string) => {
  if (!schoolId) return 'N/A'
  const school = props.schools.find((s: School) => s.id === schoolId || s._id === schoolId)
  return school ? school.name : schoolId
}

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      (selectedItemsModel.value.length > 0)
        ? (_openBlock(), _createBlock(_component_v_toolbar, {
            key: 0,
            color: "primary",
            dark: "",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(selectedItemsModel.value.length) + " request(s) selected ", 1),
                  (filledRequestIds.value.length < selectedItemsModel.value.length && filledRequestIds.value.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(filledRequestIds.value.length) + " filled) ", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              (__props.isAdmin)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('bulkEdit', selectedItemsModel.value))),
                    "prepend-icon": "mdi-pencil"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Bulk Edit ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (anySelectedAreFilled.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    variant: "text",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('bulkMarkDelivered', filledRequestIds.value))),
                    "prepend-icon": "mdi-truck-delivery"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" Mark Delivered ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (anySelectedAreFilled.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    variant: "text",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('printDeliverySlips', filledRequestIds.value))),
                    "prepend-icon": "mdi-printer"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" Print Delivery Slips ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_data_table, {
        headers: headers,
        items: __props.requests,
        loading: __props.loading,
        "items-per-page": 10,
        "show-select": true,
        modelValue: selectedItemsModel.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedItemsModel).value = $event)),
        "item-value": "id",
        "onClick:row": _cache[5] || (_cache[5] = (event, { item }) => _ctx.$emit('selectRequest', item)),
        class: "clickable-table"
      }, {
        "item.student_name": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_avatar, {
              color: "secondary",
              size: "32"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(getInitials((item as any).student_name)), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("span", null, _toDisplayString((item as any).student_name || 'Unknown'), 1)
          ])
        ]),
        "item.school": _withCtx(({ item }) => [
          _createElementVNode("span", null, _toDisplayString(getSchoolName((item as any).school)), 1)
        ]),
        "item.equipment_type": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, { size: "small" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formatEquipmentType((item as any).equipment_type)), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        "item.minimum_rating": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            size: "small",
            color: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString((item as any).minimum_rating || 'N/A'), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        "item.status": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: getRequestStatusColor((item as any).status),
            size: "small",
            variant: "tonal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formatStatus((item as any).status)), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        "item.submitted_at": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(formatDate((item as any).submitted_at)), 1)
        ]),
        "item.actions": _withCtx(({ item }) => [
          _createElementVNode("div", {
            class: "d-flex ga-1",
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            ((item as any).status === 'pending')
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "info",
                  size: "small",
                  onClick: ($event: any) => (_ctx.$emit('fill', item as any))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      size: "small"
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-package-variant", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[10] || (_cache[10] = _createTextVNode(" Fill ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ((item as any).status === 'filled')
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  color: "success",
                  size: "small",
                  onClick: ($event: any) => (_ctx.$emit('markDelivered', item as any))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      size: "small"
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("mdi-truck-delivery", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[12] || (_cache[12] = _createTextVNode(" Deliver ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (__props.isAdmin)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  icon: "mdi-pencil",
                  size: "small",
                  variant: "text",
                  onClick: ($event: any) => (_ctx.$emit('edit', item as any)),
                  title: "Edit Request"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (__props.isAdmin)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 3,
                  icon: "mdi-delete",
                  size: "small",
                  variant: "text",
                  color: "error",
                  onClick: ($event: any) => (_ctx.$emit('delete', item as any)),
                  title: "Delete Request"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        loading: _withCtx(() => [
          _createVNode(_component_v_skeleton_loader, { type: "table-row@10" })
        ]),
        "no-data": _withCtx(() => [
          _createVNode(_component_v_alert, {
            type: "info",
            variant: "tonal",
            class: "ma-4"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode(" No requests found ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["items", "loading", "modelValue"])
    ]),
    _: 1
  }))
}
}

})